import { render, staticRenderFns } from "./StockItemRow.vue?vue&type=template&id=003ef83e&scoped=true&"
import script from "./StockItemRow.vue?vue&type=script&lang=ts&"
export * from "./StockItemRow.vue?vue&type=script&lang=ts&"
import style0 from "./StockItemRow.vue?vue&type=style&index=0&id=003ef83e&lang=scss&scoped=true&"
import style1 from "./StockItemRow.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003ef83e",
  null
  
)

export default component.exports